import * as Types from "../../action/actionTypes";

const initialState = {
  isFetching: false,
  designs: null,
  updated_designs: null,
  custome_design: null,
  updated_custome_design: null,
  settingDetail: null,
  // settingUpdateDetail: null,
  // settingGoogleUpdateDetail:null
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCHING:
      return {
        ...state,
        isFetching: true,
      };

    case Types.FETCHED_SETTING:
      return {
        ...state,
        settingDetail: action.payload.data[0],
      };

    case Types.FETCH_DESIGN:
      return {
        ...state,
        designs: action.payload.data,
      };

    case Types.UPDATE_DESIGN:
      return {
        ...state,
        updated_designs: action.payload.data,
      };
    case Types.FETCHED_CUSTOME_DESIGN:
      return {
        ...state,
        custome_design: action.payload,
      };
    case Types.UPDATED_CUSTOME_DESIGN:
      return {
        ...state,
        updated_custome_design: action.payload.data,
      };


    // case Types.UPDATE_REGISTER_TEXT_SETTING:
    //   console.log(action.payload.data)
    //   return {
    //     ...state,
    //     settingUpdateDetail: action.payload.data,
    //   };

    default:
      return state;
  }
};

export default settingReducer;
